import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { config } from './components/pages/config';
import index from './components/pages/Home';
import AboutIndex from './components/pages/About';
import ServiceIndex from './components/pages/Services';
import ContactIndex from './components/pages/Contact';
import TestimonialIndex from './components/pages/Testimonials';
import ServiceDetails from './components/pages/Services/ServiceDetails';
import NewsList from './components/pages/News/NewsList';
import NewsDetails from './components/pages/News/NewsDetails';
import NotFound from './components/common/NotFound';
import CaseStudy from './components/pages/CaseStudy/CaseStudy';
import CaseDetail from './components/pages/CaseStudy/CaseDetail';
import Privacy from './components/pages/Company-Pages/Privacy';
import Terms from './components/pages/Company-Pages/Terms-Condiitons';

const AllRoutes = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <Routes>
      <Route exact path={`${config.appUrl}`} Component={index} />
      <Route path={`${config.appUrl}about-us`} Component={AboutIndex} />
      <Route path={`${config.appUrl}services`} Component={ServiceIndex} />
      <Route
        path={`${config.appUrl}service/:slug`}
        Component={ServiceDetails}
      />
      <Route path={`${config.appUrl}contact-us`} Component={ContactIndex} />
      {/* <Route path={`${config.appUrl}testimonials`} Component={TestimonialIndex} /> */}
      <Route path={`${config.appUrl}case-studies`} Component={CaseStudy} />
      <Route path={`${config.appUrl}case-study/:slug`} Component={CaseDetail} />
      <Route path={`${config.appUrl}news-and-update`} Component={NewsList} />
      <Route path={`${config.appUrl}news/:slug`} Component={NewsDetails} />
      <Route path={`${config.appUrl}privacy-policy`} Component={Privacy} />
      <Route path={`${config.appUrl}terms-conditions`} Component={Terms} />
      <Route path={'*'} Component={NotFound} />
    </Routes>
  );
};

export default AllRoutes;
